<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
    created() {
        window.addEventListener('storage', res => {
            if (res.key === 'token' && JSON.parse(res.newValue)) {
                this.$alert('您已登录其他账号，该账号已退出登录', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type: 'warning',
                    callback: () => {
                       window.close()
                    }
                });
            }
        })
    }
}
</script>
<style lang="scss">
</style>
